import React, { useEffect } from 'react'
import Skills from '../Skills/Skills'
import WhatIdo from '../WhatIDo/WhatIdo'
import HeaderPage from '../HeadPage/HeadPage'

const Home = () => {
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  }
  useEffect(() => {
    scrollToTop()
  }, [])
  return (
    <div>
      <HeaderPage/>
      <Skills />
      {/* <WhatIdo/> */}
    </div>
  )
}

export default Home